import { ShieldAlert } from 'lucide-react';

/**
 * Shown in place of the main app content when the current user is assigned to
 * a Projects role that an administrator has made Inactive. The navigator menus
 * remain visible (this renders inside AppLayout) but no page content is served.
 */
export function InactiveRoleNotice() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="max-w-md text-center p-6">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
          <ShieldAlert className="h-6 w-6 text-muted-foreground" />
        </div>
        <h2 className="text-xl font-semibold mb-2">Access Restricted</h2>
        <p className="text-muted-foreground">
          The Projects Role to which you are assigned is currently Inactive.
          Please contact a Projects app administrator to gain access.
        </p>
      </div>
    </div>
  );
}
